module.exports = __webpack_public_path__ + "static/pinkmuslin-ab1bd01d40e5f5c83e6285e8467053e7.jpeg";